<script setup>
import { useI18n } from 'vue-i18n';
import { KEYPAD_KEYS } from 'dashboard/helper/relayVoicePhone';

// The 0-9 * # pad. Emits each key; the parent decides whether it edits a
// number or sends a digit into a live call. Long-press 0 for +.
defineProps({
  compact: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(['press']);
const { t } = useI18n();
let holdTimer;
let held = false;

const startHold = key => {
  held = false;
  if (key !== '0') return;
  holdTimer = setTimeout(() => {
    held = true;
    emit('press', '+');
  }, 600);
};
const release = key => {
  clearTimeout(holdTimer);
  if (!held) emit('press', key);
  held = false;
};
const cancel = () => {
  clearTimeout(holdTimer);
  held = false;
};
</script>

<template>
  <div
    class="grid grid-cols-3 gap-2 justify-items-center"
    role="group"
    :aria-label="t('RELAY_VOICE.KEYPAD')"
  >
    <button
      v-for="item in KEYPAD_KEYS"
      :key="item.key"
      type="button"
      :disabled="disabled"
      :aria-label="item.key === '0' ? '0 +' : item.key"
      :data-key="item.key"
      class="flex flex-col items-center justify-center rounded-full bg-n-alpha-2 text-n-slate-12 transition-colors hover:bg-n-alpha-3 active:bg-n-slate-5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand disabled:opacity-50 select-none"
      :class="compact ? 'size-12' : 'size-14'"
      @pointerdown="startHold(item.key)"
      @pointerup="release(item.key)"
      @pointerleave="cancel"
      @keydown.enter.prevent="emit('press', item.key)"
      @keydown.space.prevent="emit('press', item.key)"
    >
      <span
        class="font-display font-medium leading-none tabular-nums"
        :class="compact ? 'text-lg' : 'text-xl'"
      >
        {{ item.key }}
      </span>
      <span
        class="text-[0.625rem] tracking-widest text-n-slate-10 leading-none h-3 mt-0.5"
        aria-hidden="true"
      >
        {{ item.letters }}
      </span>
    </button>
  </div>
</template>
